import { useTranslation } from "react-i18next"

import { AlertTriangle } from "@/components/icons"
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"

import { confirmWorkflowValidationAction } from "../utils/workflow-validation-dialog-utils"

interface WorkflowValidationDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  title?: string
  description?: string
  confirmLabel?: string
}

export function WorkflowValidationDialog({
  open,
  onOpenChange,
  onConfirm,
  title,
  description,
  confirmLabel,
}: WorkflowValidationDialogProps) {
  const { t } = useTranslation()
  const resolvedTitle = title ?? t("workflowLanding.validation.title", "Workflow Warning")
  const resolvedDescription =
    description ??
    t(
      "workflowLanding.validation.description",
      "This workflow does not contain any LLM or Agent node. Without a processor node, the workflow will not produce any output."
    )
  const resolvedConfirmLabel =
    confirmLabel ?? t("workflowLanding.validation.saveAnyway", "Save Anyway")
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="text-warning-ink size-5" />
            {resolvedTitle}
          </AlertDialogTitle>
          <AlertDialogDescription>{resolvedDescription}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button className="mt-2 sm:mt-0" variant="outline" onClick={() => onOpenChange(false)}>
            {t("workflowLanding.validation.cancel", "Cancel")}
          </Button>
          <Button
            className="mt-2 sm:mt-0"
            onClick={() => confirmWorkflowValidationAction(onOpenChange, onConfirm)}
          >
            {resolvedConfirmLabel}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
